import { createFileRoute } from '@tanstack/react-router';
import { TeamPage } from '../../features/identity';

export const Route = createFileRoute('/portal/team')({ component: TeamPage });
